import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import { Logger } from '@cloudflare-monorepo/utils/logging/logger';

const LoggerContext = createContext<Logger | null>(null);

export const LoggerProvider: React.FC<{ logger: Logger; children: ReactNode }> = ({ logger, children }) => (
  <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>
);

export function useLogger(prefix?: string): Logger {
  const logger = useContext(LoggerContext);
  if (!logger) throw new Error('useLogger must be used within a LoggerProvider');
  return useMemo(() => (prefix ? logger.createChild({ prefix }) : logger), [logger, prefix]);
}
